import { reactive, readonly } from 'vue'
import type { ToastEntry } from '~/composables/useToast'

/**
 * Module-level toast queue shared by `useToast()` (writes) and `<UiToastHost>` (reads).
 *
 * Lives under `components/ui/` rather than `composables/` on purpose: Nuxt auto-imports
 * every named export from `composables/`, and this is host-only plumbing, not consumer API.
 */
export const queue = reactive<ToastEntry[]>([])

/** Read-only view for `<UiToastHost>`. */
export const toastQueue = readonly(queue)
